export const ACTIVITY_SLUG_TO_NAME_MAP = {
  none: 'No lessons marked done',
  '14-days': 'Lesson done in last 14 days',
}

export const GRADE_SLUG_TO_NAME_MAP = {
  'grade-k': 'Kindergarten',
  'grade-1': 'Grade 1',
  'grade-2': 'Grade 2',
  'grade-3': 'Grade 3',
  'grade-4': 'Grade 4',
  'grade-5': 'Grade 5',
  'grade-6': 'Grade 6',
  'grade-7': 'Grade 7',
  'grade-8': 'Grade 8',
}

export const UNIT_RANGE_SLUG_TO_NAME_MAP = {
  core: 'Units 1-4',
  rbhu: 'Recognizing Bullying and Harassment Unit',
}
